/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import CurrentHomepage from "../../pages/LandingPage";
import homepageContent from "../../content/homepageContent";
import CompactHomepage from "./CompactHomepage";
import SystemsHomepage from "./SystemsHomepage";
import StreamlinedHomepage from "./StreamlinedHomepage";

export const DEFAULT_HOMEPAGE_VERSION_ID = "streamlined";

export const homepageVersions = {
  current: {
    id: "current",
    label: "Current homepage",
    status: "legacy",
    summary: "The full product narrative currently used on the public homepage.",
    component: CurrentHomepage,
    content: homepageContent,
  },
  compact: {
    id: "compact",
    label: "Compact homepage",
    status: "draft",
    summary: "A shorter beta-access page that collapses repeated product sections.",
    component: CompactHomepage,
    content: homepageContent,
  },
  systems: {
    id: "systems",
    label: "Workflow homepage",
    status: "draft",
    summary: "A homepage direction centered on broker-connected trading workflows, automation, research, and review.",
    component: SystemsHomepage,
    content: homepageContent,
  },
  streamlined: {
    id: "streamlined",
    label: "Streamlined current",
    status: "live",
    summary: "A shorter version of the current homepage with duplicate concepts merged into fewer sections.",
    component: StreamlinedHomepage,
    content: homepageContent,
  },
};
